import Alpine from "alpinejs";
import { animate, inView, scroll } from "motion";

Alpine.data('FadeItemsIn', (config) => ({
    init(){
        const cards = Array.from(this.$el.children);

        const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        
        let yMovement = [50, 0];
        let xMovement = [0, 0]

        if(config && config.direction == 'left'){
            yMovement = [0, 0];
            xMovement = [-50, 0]
        } 
        
        
        inView(this.$el, (el) => {
            if (cards.length > 0 && !prefersReducedMotion) {
                cards.forEach((card, index) => {

                card.style.opacity = 0;
                
                let delay = index * 0.2;

                if(window.innerWidth < 750){
                    delay = 0;
                }
                
                    animate(card, {
                        opacity: [0, 1], 
                        y: yMovement,
                        x: xMovement      
                    }, {
                        delay: delay,
                        duration: 0.75,
                        easing: "ease-in-out",
                        
                    });
                });
            }
        })
    }
}));